module.exports = __webpack_public_path__ + "img/8.b42ff5f6.svg";